import { Grid } from '@mui/material'
import TabPanel from '../../../../shared/components/TabPanel'
import FavoriteItem from './FavoriteItem'
import { FavoriteItem as FavoriteItemType } from '../../models/favorites'

interface FavoritesListProps {
  data: FavoriteItemType[]
  resourceType: string
  indexPath: string
  historyPath: string
  imgPath: string
  currentTab: number
  index: number
  onFavoriteClick: (id: number, type: string, indexPath: string) => (_: boolean) => void
  onRedirectClick: (type: string, path: string, data: FavoriteItemType) => void
}

const FavoritesList = ({
  data,
  resourceType,
  indexPath,
  historyPath,
  imgPath,
  currentTab,
  index,
  onFavoriteClick,
  onRedirectClick
}: FavoritesListProps) => {
  return (
    <TabPanel value={currentTab} index={index}>
      <Grid container spacing={2}>
        {data.map(item => (
          <FavoriteItem
            key={item.id}
            item={item}
            resourceType={resourceType}
            indexPath={indexPath}
            historyPath={historyPath}
            imgPath={imgPath}
            onFavoriteClick={onFavoriteClick}
            onRedirectClick={onRedirectClick}
          />
        ))}
      </Grid>
    </TabPanel>
  )
}

export default FavoritesList
